import { render, staticRenderFns } from "./DataSetContextMenuRecycle.vue?vue&type=template&id=f34dc898"
import script from "./DataSetContextMenuRecycle.vue?vue&type=script&lang=js"
export * from "./DataSetContextMenuRecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports